import { CANCELLED, APPROVED, TIMESHEET_AWAITING_APPROVAL } from '../../common/graphql/constants';

export function currentPositions(positions) {
  return positions
    .filter(position => ![APPROVED, CANCELLED].includes(position.status))
    .map((position) => {
      const isApprovable = position.status === TIMESHEET_AWAITING_APPROVAL;

      return { ...position, isApprovable };
    });
}

export function pastPositions(positions) {
  return positions
    .filter(position => [APPROVED, CANCELLED].includes(position.status) && position.weployee !== null);
}
